import React from 'react';
import EnrollmentWorkqueue from './EnrollmentWorkqueue';

const AllEnrollments = () => (
  <EnrollmentWorkqueue enrollmentStatus="" />
);

export default AllEnrollments;
